import PropTypes from 'prop-types';
import React, { useState } from 'react';

import {
    Footer,
    Header,
    Meta
} from '$partials/global';

import { AwardsModuleNomineesLandingHeader } from '$partials/modules/individual';
import ModuleDispatcher from '$partials/modules/dispatcher';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const AwardsNomineesPage = ({
    data,
    domain
}) => {
    // state
    const [ filterCategory, setFilterCategory ] = useState('all');

    // misc
    const page = data?.page;

    // render
    return (
        <>
            {/* meta */}
            <Meta page={page} />

            {/* main */}
            <main
                className='bg-grey min-h-screen overflow-hidden'
                id='main-content'>

                <div className='layout-container relative z-20'>
                    {/* header */}
                    <Header
                        menu={data?.navigation}
                        search={data?.search}
                        title={page.title} />
                </div>

                <article>
                    {/* landing header */}
                    <AwardsModuleNomineesLandingHeader
                        bannerCopy={page?.bannerCopy}
                        bannerTitle={page?.bannerTitle}
                        filterCategory={filterCategory}
                        images={page.images?.items}
                        logo={page?.logo}
                        setFilterCategory={setFilterCategory}
                        title={page?.title} />

                    {/* modules */}
                    {(page.modules?.items?.length > 0) && (
                        page.modules.items.map((module, idx) => {
                            if (!module) { return null; }

                            // if module's category does not match category filter do not render it
                            if (
                                filterCategory !== 'all'
                                && module.__typename === 'BvaMagazineAwardsNomineesModuleCategory'
                                && module.category !== filterCategory
                            ) {
                                return null;
                            }

                            return (
                                <ModuleDispatcher
                                    key={idx}
                                    module={module}
                                    nextTypename={page.modules.items[idx + 1]?.__typename}
                                    previousTypename={page.modules.items[idx - 1]?.__typename} />
                            );
                        })
                    )}
                </article>

                <div className='layout-container'>
                    {/* end content border */}
                    <div className='border-b mt-60 md:mt-80 mx-10 sm:mx-20' />

                    {/* footer */}
                    <Footer
                        domain={domain}
                        menu={data?.footer}
                        title='Strava Awards' />
                </div>
            </main>
        </>
    );
};

/* =========================================================================  */
/* Typing and exports */
/* =========================================================================  */

const propTypes = {
    data: PropTypes.object.isRequired,
    domain: PropTypes.string
};

AwardsNomineesPage.propTypes = propTypes;

export default AwardsNomineesPage;
